import { useGetOntology } from "core/model/utils/ontologies/hooks";
import { isPrintMode } from "core/model/utils/urls";
import { VerticalLayout } from "ds_legacy/materials/layouts";
import { margin } from "ds_legacy/materials/metrics";
import { Body } from "ds_legacy/materials/typography";
import { EmptiableField } from "dsl/organisms/PatientProfileDetailsShared/shared";
import { useTranslations } from "translations";

const isGrantChecked = (value: number | null | undefined): boolean =>
  (value && value > 0) || false;

export default function ReliefServiceGrant({
  testId,
  value,
}: {
  testId: string;
  value: number | null | undefined;
}) {
  const getOntology = useGetOntology();
  const translations = useTranslations();
  const isPrint = isPrintMode();

  const title = translations.patient.reliefServices;
  const isChecked = isGrantChecked(value);
  const ontolgyValue = getOntology({ key: value, type: "reliefServices" });

  if (isPrint) {
    return isChecked ? (
      <Body>
        {title}
        {value && `${translations.general.colon} ${ontolgyValue}`}
      </Body>
    ) : null;
  }

  return isChecked ? (
    <VerticalLayout margin={margin(0)}>
      <EmptiableField
        testId={testId}
        title={value ? title : ""}
        value={value ? ontolgyValue : title}
      />
    </VerticalLayout>
  ) : null;
}
